export default __webpack_public_path__ + "images/welcome_shop.png";